import { render, staticRenderFns } from "./MspForsageGroupItem.vue?vue&type=template&id=0b8918f2"
import script from "./MspForsageGroupItem.vue?vue&type=script&lang=js"
export * from "./MspForsageGroupItem.vue?vue&type=script&lang=js"
import style0 from "./MspForsageGroupItem.vue?vue&type=style&index=0&id=0b8918f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports